export default __webpack_public_path__ + "static/media/react.7e9e8696.png";